export default __webpack_public_path__ + "08cf4ca2eb5de5c1f121bca77636e1ed.png";